class CookieNotice extends HTMLElement {
  constructor () {
    super()

    window.Shopify.loadFeatures([
      {
        name: 'consent-tracking-api',
        version: '0.1',
      }
    ], (error) => {
      if (error) throw error

      this.initCookieBanner()
    })
  }

  initCookieBanner() {
    const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked()
    const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent()

    if(!userCanBeTracked && userTrackingConsent === 'no_interaction') {
      this.showBanner()
      this.declineTrigger = [...this.querySelectorAll('.js-cookie-notice-decline')]
      this.acceptTrigger = [...this.querySelectorAll('.js-cookie-notice-accept')]

      this.declineTrigger.forEach((trigger) => {
        trigger.addEventListener('click', this.handleDecline.bind(this))
      })

      this.acceptTrigger.forEach((trigger) => {
        trigger.addEventListener('click', this.handleAccept.bind(this))
      })
    }
  }

  getBannerEl() {
    return document.getElementById('cookies-banner')
  }

  hideBanner() {
    this.classList.add('hidden')
  }

  showBanner() {
    this.classList.remove('hidden')
  }

  handleAccept(e) {
    window.Shopify.customerPrivacy.setTrackingConsent(true, this.hideBanner.bind(this))

    document.addEventListener('trackingConsentAccepted', () => {
      console.log('trackingConsentAccepted event fired')
    })
  }

  handleDecline() {
    window.Shopify.customerPrivacy.setTrackingConsent(false, this.hideBanner.bind(this))
  }
}

window.customElements.define('cookie-notice', CookieNotice)
